import { LayoutType, withLayout } from 'hocs/with-layout';
import { SignInOnboarding } from './sign-in-onboarding';

const WrappedSignIn = withLayout(LayoutType.WithOldNavOnly, SignInOnboarding);

export { WrappedSignIn as SignInOnboarding };
